import { internalApiPath } from 'api/internal/internal.constants'

export const bundleNameApiPath = '/bundle-name'

export const fetchBundleNameApi = async (): Promise<string> => {
  const response = await fetch(internalApiPath + bundleNameApiPath)
  return await response.json()
}
